import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Loader from "App/common/ui/Loader";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";
import { ReactComponent as SliderEditIcon } from "assets/images/app_svg/slider_edit.svg";
import {
  forbidExtraProps,
  deepClone,
  deepCompare,
  isDecodable,
  decodeHandler,
  displayBackupSchedule
} from "utils";

import { ReactComponent as CloseIcon } from "assets/images/app_svg/close.svg";
import BackupPlanFooter from "./Footer";
import { LayoutContext } from "./../../../../common/hoc/Layout/index";
import { SPopupContext } from "App/common/hoc/SlidingPopup";

function BackupPlanSummary(props) {
  const { sPopupState, sPopupMethods } = React.useContext(SPopupContext);
  const { lState, lMethods } = React.useContext(LayoutContext);
  const lStateRef = useRef();

  const [planSettings, setPlanSettings] = React.useState(
    deepClone(
      props.currentPanel.params && props.currentPanel.params.planSettings
        ? props.currentPanel.params.planSettings
        : lState.slidingPopup.params.isNew
        ? props.defaultPlanDetails
        : props.backupPlans.data[lState.slidingPopup.params.planID]
    )
  );
  const [editPlanName, setEditPlanName] = React.useState({
    name:
      props.currentPanel.params && props.currentPanel.params.planSettings
        ? props.currentPanel.params.planSettings.planName
        : lState.slidingPopup.params.isNew
        ? props.defaultPlanDetails.planName
        : props.backupPlans.data[lState.slidingPopup.params.planID].planName,
    edit: false
  });
  const [conflict, setConflict] = React.useState({
    conflicts: [{ devices: [], planName: "" }],
    isConflict: false,
    planName: ""
  });
  const [originalSettings, setOriginalSettings] = React.useState(
    deepClone(
      props.currentPanel.params && props.currentPanel.params.planSettings
        ? props.currentPanel.params.planSettings
        : props.backupPlans.data[lState.slidingPopup.params.planID]
    )
  );
  /*****************************Handling  popup using enter key ***************************/
  useEffect(() => {
    lStateRef.current = lState;
    const handleKeyDown = e => {
      if (
        e.key === "Enter" &&
        lStateRef.current.popup.show &&
        lStateRef.current.popup.alertName === "backupPlanConflict"
      ) {
        lStateRef.current.popup.params.execute();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [lState]);

  function displayEmailLists(emailNotification) {
    if (!emailNotification.emails || emailNotification.emails === null) {
      return "No emails added";
    }
    if (
      emailNotification.emails.length === 0 ||
      (emailNotification.emails.length === 1 &&
        emailNotification.emails[0] === "")
    ) {
      return "No emails added";
    }
    return emailNotification.emails.length > 0
      ? emailNotification.emails.length > 1
        ? emailNotification.emails[0] +
          " and " +
          (emailNotification.emails.length - 1) +
          (" other" +
            (emailNotification.emails.length > 2 ? "s Email IDs" : " Email ID"))
        : emailNotification.emails[0]
      : "";
  }

  React.useEffect(() => {
    let tempConflict = {
      conflicts: [],
      isConflict: false,
      planName: planSettings.planName
    };
    if (
      !deepCompare(planSettings.devices, props.cacheSettings.devices) &&
      planSettings.devices.length > 0
    ) {
      let tempDevicesData = deepClone(props.backupPlans.data);
      delete tempDevicesData[planSettings.planId];
      for (let plan in tempDevicesData) {
        let abc = { planName: tempDevicesData[plan].planName, devices: [] };
        for (let dev in planSettings.devices) {
          const tempMainSettings = deepClone(tempDevicesData[plan]);
          delete tempMainSettings.log;
          if (
            tempDevicesData[plan].status !==
              props.enums.BackupPlanStatus.DELETED &&
            JSON.stringify(tempMainSettings.devices).includes(
              planSettings.devices[dev].clientUUID
            )
          ) {
            tempConflict.isConflict = true;
            abc.devices.push(planSettings.devices[dev].clientName);
          }
        }
        if (abc.devices.length > 0) {
          tempConflict.conflicts.push(abc);
        }
      }
    }
    setConflict(tempConflict);
  }, [planSettings.devices]);

  React.useEffect(() => {
    if (
      !planSettings.emailNotification.emails ||
      planSettings.emailNotification.emails === null
    ) {
      setPlanSettings({
        ...planSettings,
        emailNotification: {
          ...planSettings.emailNotification,
          emails: [],
          enabled: false
        }
      });
    }
  }, []);

  return (
    <React.Fragment>
      {props.planSettings.loading ||
      (lState.slidingPopup.params.isNew && !props.defaultPlanDetails) ? (
        <Loader />
      ) : (
        <div className="create_plan_summary">
          <p className="create_plan_summaryCont">
            <span>
              {lState.slidingPopup.params.isNew ? "Create" : "Update"} a backup
              plan and push it to computers
            </span>
            {lState.slidingPopup.params.isNew && (
              <Tooltip {...TOOLTIPS.backupPlan.settings.default.new}>
                <span className="icon">
                  <InformationIcon />
                </span>
              </Tooltip>
            )}
            {!lState.slidingPopup.params.isNew && (
              <Tooltip {...TOOLTIPS.backupPlan.settings.default.update}>
                <span className="icon">
                  <InformationIcon />
                </span>
              </Tooltip>
            )}
          </p>
          <div className="slider_content is_relative">
            <div className="create_plan_head">
              {!editPlanName.edit && (
                <h2
                  onClick={() => {
                    setEditPlanName({ ...editPlanName, edit: true });
                  }}
                >
                  <span>
                    {isDecodable(planSettings.planName)
                      ? decodeHandler(planSettings.planName)
                      : planSettings.planName}
                  </span>
                  <Tooltip {...TOOLTIPS.backupPlan.settings.edit}>
                    <span className="icon edit_name_icon">
                      <span className="svg_edit_slider_icon">
                        <SliderEditIcon />
                      </span>
                    </span>
                  </Tooltip>
                </h2>
              )}

              <div
                className="comp_nameEdit"
                style={{ display: editPlanName.edit ? "block" : "none" }}
              >
                <input
                  type="text"
                  name=""
                  maxLength="50"
                  ref={input => input && input.focus()}
                  value={
                    isDecodable(editPlanName.name)
                      ? decodeHandler(editPlanName.name)
                      : editPlanName.name
                  }
                  onChange={e =>
                    setEditPlanName({ ...editPlanName, name: e.target.value })
                  }
                  autoFocus={editPlanName.edit}
                  onKeyPress={e => {
                    if (
                      editPlanName.name.trim() !== planSettings.planName &&
                      editPlanName.name.trim() !== "" &&
                      e.key == "Enter"
                    ) {
                      setPlanSettings({
                        ...planSettings,
                        planName: editPlanName.name
                      });
                      setEditPlanName({ ...editPlanName, edit: false });
                    }
                  }}
                />
                <button
                  className={[
                    "btn_primary ",
                    editPlanName.name.trim() === planSettings.planName ||
                    editPlanName.name.trim() === ""
                      ? "btn_disable"
                      : ""
                  ].join(" ")}
                  onClick={() => {
                    if (
                      editPlanName.name.trim() !== planSettings.planName &&
                      editPlanName.name.trim() !== ""
                    ) {
                      setPlanSettings({
                        ...planSettings,
                        planName: editPlanName.name
                      });
                      setEditPlanName({ ...editPlanName, edit: false });
                    }
                  }}
                >
                  Save
                </button>
                <span
                  className="icon close_edit_icon"
                  data-toggle="tooltip"
                  data-placement="right"
                  data-original-title="Close"
                  onClick={() => {
                    setEditPlanName({
                      name: planSettings.planName,
                      edit: false
                    });
                  }}
                >
                  <span className="svg_close_slider_icon">
                    <svg
                      id="svg_slider_close_icon"
                      data-name="Layer 1"
                      viewBox="0 0 13.31 13.31"
                    >
                      <polygon
                        className="cls-slider-close-icon"
                        points="13.31 1.82 11.49 0 6.66 4.84 1.82 0 0 1.82 4.84 6.66 0 11.49 1.82 13.31 6.66 8.47 11.49 13.31 13.31 11.49 8.47 6.66 13.31 1.82"
                      ></polygon>
                    </svg>
                  </span>
                </span>
              </div>
            </div>
            {conflict.isConflict && (
              <div className="conflict_alert">
                <div className="conflict_alert_cont">
                  Conflict Alert!{" "}
                  <a
                    className="viewConflict"
                    onClick={() =>
                      lMethods.openPopup("backupPlanConflict", {
                        execute: () => {
                          lMethods.closePopup();
                        },
                        conflict: conflict
                      })
                    }
                  >
                    View details
                  </a>
                </div>
              </div>
            )}
            <div className="summary_setting_wrap">
              <div
                className="summary_setting__item addDevice"
                onClick={() =>
                  props.switchPanel("edit", "addDevices", {
                    planSettings,
                    setPlanSettings
                  })
                }
              >
                <div className="summary_setting__title"> Devices:</div>
                <div className="summary_setting__select">
                  {" "}
                  {planSettings.devices.length > 0
                    ? planSettings.devices.map((dev, i) => {
                        if (i === 9) {
                          return (
                            <span className="moreDevice">
                              {"+" +
                                (planSettings.devices.length - i) +
                                " more"}
                            </span>
                          );
                        } else if (i > 9) return null;
                        else
                          return (
                            <span className="devceName">
                              {decodeHandler(dev.clientName) +
                                (i !== planSettings.devices.length - 1
                                  ? ", "
                                  : "")}
                            </span>
                          );
                      })
                    : "Add"}{" "}
                </div>
                <div className="summary_setting__icon">
                  <Tooltip {...TOOLTIPS.backupPlan.settings.edit}>
                    <span className="icon">
                      <SliderEditIcon />
                    </span>
                  </Tooltip>
                </div>
              </div>
              <div className="summary_setting__item summary_setting__item_6">
                <div className="summary_setting__title"> What to backup? </div>
                <div className="summary_setting__select">
                  <div className="main_select">
                    <select
                      value={planSettings.backupSource}
                      onChange={e =>
                        setPlanSettings({
                          ...planSettings,
                          backupSource: +e.target.value
                        })
                      }
                    >
                      <option value={1}>Entire PC</option>
                      <option value={2}>Only OS Drive</option>
                    </select>
                  </div>
                </div>
                {/* <div className="summary_setting__icon">
                  <Tooltip {...TOOLTIPS.backupPlan.settings.edit}>
                    <span className="icon">
                      <SliderEditIcon />
                    </span>
                  </Tooltip>
                </div> */}
              </div>
              {/* <div className="summary_setting__item summary_setting__item_6">
                                <div className="summary_setting__title"> Where to backup? </div>
                                <div className="summary_setting__select">{props.enums.BackupType.props[planSettings.backupType].key.charAt(0).toUpperCase() + props.enums.BackupType.props[planSettings.backupType].key.slice(1).toLowerCase() + " Backup"}
                                    <div className="main_select">
                                        <select>
                                            <option value="cloud_backup">Cloud Backup</option>
                                            <option value="local_backup" selected="">Local Backup</option>
                                        </select>
                                    </div>

                                </div>
                            </div> */}
              <div
                className="summary_setting__item schedule_opt"
                onClick={() =>
                  props.switchPanel("edit", "schedule", {
                    planSettings,
                    setPlanSettings
                  })
                }
              >
                <div className="summary_setting__title">Schedule </div>
                <div className="summary_setting__select">
                  {" "}
                  {displayBackupSchedule(
                    planSettings.scheduleInfo,
                    props.enums
                  )}{" "}
                </div>
                <div className="summary_setting__icon">
                  <Tooltip {...TOOLTIPS.backupPlan.settings.edit}>
                    <span className="icon">
                      <SliderEditIcon />
                    </span>
                  </Tooltip>
                </div>
              </div>
              <div
                className="summary_setting__item advSettings_opt"
                onClick={() =>
                  props.switchPanel("edit", "advanceSettings", {
                    planSettings,
                    setPlanSettings
                  })
                }
              >
                <div className="summary_setting__title"> Advance Settings </div>
                <div className="summary_setting__select">
                  {" "}
                  {"Cleanup after " +
                    planSettings.cleanup.scheduleCount +
                    " incremental backup"}{" "}
                </div>
                <div className="summary_setting__icon">
                  <Tooltip {...TOOLTIPS.backupPlan.settings.edit}>
                    <span className="icon">
                      <SliderEditIcon />
                    </span>
                  </Tooltip>
                </div>
              </div>
              <div
                className="summary_setting__item emailNotify_opt"
                onClick={() =>
                  props.switchPanel("edit", "email", {
                    planSettings,
                    setPlanSettings
                  })
                }
              >
                <div className="summary_setting__title">
                  {" "}
                  Email Notification:{" "}
                </div>
                <div className="summary_setting__select">
                  {" "}
                  {displayEmailLists(planSettings.emailNotification)}{" "}
                </div>
                <div className="summary_setting__icon">
                  <Tooltip {...TOOLTIPS.backupPlan.settings.edit}>
                    <span className="icon">
                      <SliderEditIcon />
                    </span>
                  </Tooltip>
                </div>
              </div>
            </div>
            <BackupPlanFooter
              {...{
                planSettings: planSettings,
                isSummary: true,
                originalSettings: originalSettings,
                setOriginalSettings: setOriginalSettings
              }}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

BackupPlanSummary.propTypes = forbidExtraProps(
  {
    backupPlans: PropTypes.object
  },
  ["enums"]
);

function mapStateToProps(state) {
  return {
    backupPlans: state.backupPlan.backupPlans,
    enums: state.common.enums,
    planSettings: state.backupPlan.settings,
    cacheSettings: state.backupPlan.cachePlanSettings,
    defaultPlanDetails: state.backupPlan.defaultPlanDetails
  };
}

export default connect(mapStateToProps)(BackupPlanSummary);
